import React, { useContext, useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'

import { useRemoteStrings } from '@acorns/web-utils'
import { compose } from 'recompose'

import Layout from 'components/Layout'
import Nav from 'components/Nav'
import Separator from 'components/Separator'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { ActionType, PageName } from 'generated/types'
import { TestIDs } from 'test/utils/testIds'
import theme from 'theme'
import trackEvent from 'utils/analytics/trackEvent'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { getFlow } from 'utils/FlowProvider/utils'
import { FunnelContext } from 'utils/FunnelContext'

import ProgressImage from '../assets/progress-image.svg'
import { getStepsData } from '../shared/StepsData'
import { ActionWrapper, Container, StyledTitle } from '../shared/styled-components'
import {
  StyledBody,
  StyledButton,
  StyledFootnote,
  StyledImage,
  Wrapper,
  WrapperBackground,
} from '../shared/styled-components'
import { VerticalProgressBar } from '../shared/VerticalProgressBar'
import { NextButtonTappedEvent, ScreenViewedEvent } from './events'

type Props = WithFlowRouterProps

const enhance = compose<Props, {}>(withFlowRouter)

const MOCProgressStepOne: React.FunctionComponent = ({ route }) => {
  const isMobile = useMediaQuery({ maxWidth: `${theme.breakpoints.sm}px` })
  const { isDynamicFunnelEnabled, routeToPage } = useContext(FunnelContext)
  const { getRemoteString } = useRemoteStrings()

  const stepsData = getStepsData({ getRemoteString })

  useEffect(() => {
    trackEvent('Screen Viewed', {
      eventData: ScreenViewedEvent,
      flow: getFlow(),
    })
  }, [])

  const handleNext = () => {
    trackEvent('Button Tapped', {
      eventData: NextButtonTappedEvent,
      flow: getFlow(),
    })
    isDynamicFunnelEnabled
      ? routeToPage(PageName.ProgressScreen_1, ActionType.Continue)
      : route({ from: FlowRoute.MOCProgressStepOne, action: 'continue' })
  }

  return (
    <>
      <Nav
        back={true}
        backClickTracker={TRACKER_IDS.MOC_PROGRESS_STEP_ONE.BACK_BUTTON}
        hideHeader={isMobile}
      />
      <Layout>
        <Wrapper>
          <Container>
            <StyledTitle data-testid={TestIDs.MOC_PROGRESS_ONE.TITLE}>
              {getRemoteString({ key: 'registration.moc_feature_lander.step_1.headline' })}
            </StyledTitle>
            <StyledBody>
              {getRemoteString({ key: 'registration.moc_feature_lander.step_1.body_text' })}
            </StyledBody>
            <VerticalProgressBar index={0} steps={stepsData} progress={0} />
            <StyledFootnote>
              {getRemoteString({ key: 'registration.moc_feature_lander.footnote' })}
            </StyledFootnote>
            {!isMobile && <StyledImage src={ProgressImage} alt="moc-progress" />}
          </Container>
        </Wrapper>
        <WrapperBackground backgroundUrl={isMobile ? ProgressImage : ''}>
          <ActionWrapper>
            <Separator />
            <StyledButton data-testid={TestIDs.MOC_PROGRESS_ONE.NEXT_BUTTON} onPress={handleNext}>
              {getRemoteString({ key: 'registration.moc_feature_lander.step_1.cta_text' })}
            </StyledButton>
          </ActionWrapper>
        </WrapperBackground>
      </Layout>
    </>
  )
}

export default enhance(MOCProgressStepOne)
